import {
  getAllMusicAction,
  getMusicAction,
  addMusicAction,
  musicErrorAction,
} from "./musicAction";
import { LOADING } from "./musicTypes";
import axios from "axios";

const MUSIC_API = "http://localhost:3100/api/v1/musics";

const token = sessionStorage.getItem("auth_user");
let new_token = token !== null && JSON.parse(token).token;

const multipart_header = {
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: `Bearer ${new_token}`,
  },
};
const json_header = {
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${new_token}`,
  },
};

export const getAllMusic = async (dispatch, page = 1, limit = 10) => {
  dispatch({ type: LOADING, payload: true });
  try {
    const response = await axios.get(
      `${MUSIC_API}?page=${page}&limit=${limit}`,
      json_header
    );
    console.log('response: ', response.data.data)
    dispatch({ type: LOADING, payload: false });
    dispatch(getAllMusicAction(response.data.data));
  } catch (error) {
    dispatch({ type: LOADING, payload: false });
    const network = { network: "No Network" };
    dispatch(
      musicErrorAction(
        error.response === undefined ? network : error.response.data.error
      )
    );
  }
};

export const getMusic = async (dispatch, music_id) => {
  try {
    const response = await axios.get(`${MUSIC_API}/${music_id}`, json_header);
    dispatch(getMusicAction(response.data.data));
  } catch (error) {
    const network = "No Network";
    dispatch(
      musicErrorAction(
        error.response === undefined ? network : error.response.data.error
      )
    );
  }
};

export const addMusic = async (dispatch, music) => {
  try {
    const response = await axios.post(`${MUSIC_API}`, music, multipart_header);
    dispatch(addMusicAction(response.data.data));
  } catch (error) {
    console.log(error.response);
    const network = "No Network";
    dispatch(
      musicErrorAction(
        error.response === undefined ? network : error.response.data.error
      )
    );
  }
};
export const updateMusic = async (dispatch, music) => {
  try {
    const response = await axios.put(`${MUSIC_API}`, music, multipart_header);
    dispatch(addMusicAction(response.data.data));
  } catch (error) {
    console.log(error.response);
    const network = "No Network";
    dispatch(
      musicErrorAction(
        error.response === undefined ? network : error.response.data.error
      )
    );
  }
};
